import { useNavigate } from 'react-router-dom';
import { useSyncStatus } from '../../sync/engine';

/** ヘッダーの同期ステータス（仕様書 §7.8）。 */
export function SyncIndicator({ compact = false }: { compact?: boolean }) {
  const s = useSyncStatus();
  const navigate = useNavigate();

  const view = (() => {
    switch (s.state) {
      case 'syncing':
        return { icon: '↻', label: s.message ?? '同期中', cls: 'is-syncing', title: s.message ?? '同期中' };
      case 'offline':
        return { icon: '⛅', label: 'オフライン', cls: 'is-offline', title: 'オフラインです。変更は端末に保存されています。' };
      case 'reauth':
        return { icon: '🔒', label: '要サインイン', cls: 'is-reauth', title: 'サインインし直すと同期を再開します' };
      case 'error':
        return { icon: '⚠', label: '同期エラー', cls: 'is-error', title: s.error ?? '同期に失敗しました' };
      default:
        return s.pending > 0
          ? { icon: '↑', label: `${s.pending}`, cls: 'is-pending', title: `未同期の変更が ${s.pending} 件あります` }
          : { icon: '✓', label: '同期済み', cls: 'is-ok', title: `最終同期 ${s.lastSyncAt ? new Date(s.lastSyncAt).toLocaleTimeString('ja-JP') : '—'}` };
    }
  })();

  return (
    <button
      className={`sync-chip ${view.cls}${compact ? ' compact' : ''}`}
      title={view.title}
      onClick={() => navigate('/settings')}
    >
      <span className="sync-icon" aria-hidden>
        {view.icon}
      </span>
      {!compact && <span className="sync-label">{view.label}</span>}
    </button>
  );
}
